import { makeStyles } from "@mui/styles";

export const useStyle = makeStyles((theme) => ({
    pagination:{
        '&.MuiPaginationItem-root':{
          borderRadius:"3px",
          padding:"10px",
          '& .MuiSvgIcon-root':{
            fontSize:30,
            background:'#1972d2',
            color:"white",
            borderRadius:'3px'
          }
        }
       },
       footer:{
        '&.MuiGrid-root':{     
        display:'flex',
        justifyContent:'space-between',
        backgroundColor:"#fff",
        borderTop:`1px solid #ccc`,
        padding:"6px",
        alignItems:'center'
        } 
    },
    pagination:{
      '&.MuiPaginationItem-root':{
          // backgroundColor:"red",
          borderRadius:"5px",
          padding:"10px",

          '&.Mui-selected':{
          backgroundColor:"#A06EE1",
          '&:hover': {
              backgroundColor: '#ccc', // Replace with your desired hover color
              color: '#000', // Replace with your desired hover text color
          },
          },
          
          '& .MuiSvgIcon-root':{
              fontSize:24
          }
      }
  },
  paginationOne:{
    '&.MuiGrid-root':{     
    display:'flex',
    alignItems:'center',
    } 
}, 
  paginationAutocomplete:{
    '&.MuiTextField-root':{
    padding:'0px',
    width:'65px',
    }
},
dataTable:{
    '&.MuiDataGrid-root':{
        position:'relative',
        "& .MuiDataGrid-virtualScroller": {
          overflowX:"scroll",
          scrollbarWidth: "thin",
        },
        "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
          width: "10px",
          height: "10px",
        },
        "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track": {
          background:theme.palette.grey[100],
        },
        "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
          border: "2px solid #A9A9A9",
          borderRadius:"20px",
          backgroundColor:"#ffff",
        },
        '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within':{
          outline:"none !important",
        },
        '& .MuiDataGrid-columnHeaders':{
          backgroundColor:theme.palette.primary.main,
          color:theme.palette.common.white,
        },
       '&.MuiDataGrid-main':{
         height:'55vh',
      },
      "&.MuiDataGrid-cell--textCenter":{
        textAlign:'center'
      },
      '&.MuiDataGrid-root .MuiDataGrid-header':{
          position: "sticky",
          top: 0,
          zIndex: 1,
        },
       '&.MuiDataGrid-menuIcon':{
         display:'none',
       },
       '&.MuiDataGrid-sortIcon':{
          display:'none',
          color:'white'
        },
      },
      row: {
          backgroundColor:theme.palette.common.white,
        '&:hover':{
          backgroundColor:theme.palette.common.white,
        }
    }
},
tblRoot: {
  "&.MuiTableContainer-root": {
    height: "100%",
    "&::-webkit-scrollbar": {
      width: "10px",
    },
    "&:hover::-webkit-scrollbar": {
      display: "block",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: theme.palette.grey[100],
    },
    "&::-webkit-scrollbar-thumb": {
      border: "2px solid #A9A9A9",
      borderRadius: "20px",
      backgroundColor: theme.palette.common.white,
      backgroundClip: "content-box",
    },
  },
},
table: {
  position: "relative",
  // outline: `0.5px solid #ccc`,
  borderRadius: "4px",
},
tablrow: {
  "&.MuiTableRow-root": {
    "& .MuiTableCell-root": {
      textAlign: "center",
      padding: "6px",
      borderRight: `1px solid #ccc`,
    },
  },
},
tablrow1: {
  "&.MuiTableRow-root": {
    "& .MuiTableCell-root": {
      textAlign:"right",
      padding: "6px",
      borderRight: `1px solid #ccc`,
    },
  },
},
tblHeader: {
  "&.MuiTableHead-root": {
    "& .MuiTableCell-root": {
      fontWeight: 600,
      backgroundColor: "#ba68c8",
      paddingBlock: "6px",
      color: "#fff",
      letterSpacing: 1,
    },
  },
},
tblContentCell: {
  "&.MuiTableCell-root": {
    textAlign: "center",
    padding: "0px",
    borderBottom:'0.5px solid  #ccc',
    "& .MuiTextField-root": {
      "& .MuiOutlinedInput-root": {
        height: 30,
        padding: 0,
        // backgroundColor: theme.palette.grey[50],
        "& fieldset": {
          borderColor: "#fff",
          borderWidth: "1.4px",
        },
        "&:hover fieldset": {
          borderColor: "#fff",
          borderWidth: "1.4px",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#fff",
          borderWidth: "1.4px",
        },
      },
    },
    // border: `1px solid #ccc`,
  },
  
},
}))